export const introStore = {
    namespaced: true,
    state: {
        simulatorDB: {
            step: 6,
            stack: [],
            crtIdx: -1,
            lock: false
        },
        missionDB: {
            step: 4,
            stack: [],
            crtIdx: -1,
            lock: false
        },
        executeWd: {}, 
        rect: {},
        show: false,
        showBlockWindow: false,
        currentExe: '',
        showBox: false,
        showMissionIntro: false,
    },
    actions: {
        excuteStackSimulator_ ({ state, commit }, [ { type, index }, oof ]) {
            // console.log('excuteStackSimulator_', oof, state[type].crtIdx)
            // console.log(state.simulatorDB.lock)
            if ( !(state[type].stack.filter(fo => fo).length === state[type].step) ) return console.error('Execution condition not allowed')
            const indx = oof ? state[type].crtIdx + oof : oof === 0 ? state[type].step - 1 :index
            commit('upShow', [ true ])
            commit('upShowBlockWindow', [ false ])
            commit('upExecuteWd', [ indx, type ])
            commit('upRect', [ { md: state.executeWd.md } ])
            commit('updSimulatorDB', [ { crtIdx: indx } ])
            commit('upCurrentExe', [ type ])
            // console.log('excuteStackSimulator_', oof, state[type].crtIdx)
        },
        excuteStackMission_ ({ state, commit }, [ { type, index }, oof ]) {
            if (state.missionDB.lock) return
            // console.log('excuteStackMission_', oof, state[type].crtIdx)
            const indx = oof ? state[type].crtIdx + oof : oof === 0 ? state[type].step - 1 : index
            commit('upShow', [ true ])
            commit('upShowBlockWindow', [ false ])
            commit('upExecuteWd', [ indx, type ])
            commit('upRect', [ { md: state.executeWd.md } ])
            commit('updMissionDB', [ { crtIdx: indx } ])
            commit('upCurrentExe', [ type ])
            // console.log('excuteStackMission_', oof, state[type].crtIdx)
        },
        excuteNextTick_ ({ commit, state, dispatch }, [ { oof = 1 } = {} ] = []) {
            const curexe = state.currentExe
            if (state[curexe].crtIdx === state[curexe].step - 1 && curexe !== 'simulatorDB') {
                commit('upLock', [ true, curexe ])
                localStorage.setItem(curexe, true)
            }
            commit('upShow', [ false ])
            commit('upShowBlockWindow', [ false ])
            if (state[curexe].step - 1 > state[curexe].crtIdx) {
                if (oof === 0) {
                    const ab = { simulatorDB: "excuteStackSimulator_", missionDB: "excuteStackMission_" }
                    dispatch(ab[curexe], [ { type: curexe }, oof ])
                } else if (curexe === 'simulatorDB') {
                    dispatch('excuteStackSimulator_', [ { type: 'simulatorDB' }, oof ])
                }
            }
            state.executeWd.to && state.executeWd.to()
        }
    },
    mutations: {
        updMissionDB (state, [ payload ]) {
            // console.log('updMissionDB -> store', payload, state)
            const o = state.missionDB
            if (o.lock) return
            Object.entries(payload).forEach(([ key, val ]) => {
                if (typeof o[key] === 'object') {
                    o[key] = o[key] instanceof Array ? (() => {
                        val.forEach(e => o[key][e.index] = e)
                        return o[key]
                    })() : { ...o[key], ...val }
                } else {
                    o[key] = val
                }
            })
        },
        updSimulatorDB (state, [ payload ]) {
            // console.log('updSimulatorDB -> store', payload, state)
            const o = state.simulatorDB
            Object.entries(payload).forEach(([ key, val ]) => {
                if (typeof o[key] === 'object') {
                    o[key] = o[key] instanceof Array ? (() => {
                        val.forEach(e => o[key][e.index] = e)
                        return o[key]
                    })() : { ...o[key], ...val }
                } else {
                    o[key] = val
                }
            })
        },
        upRect (state, [ payload ]) {
            state.rect = Object.assign({}, state.rect, payload)
        },
        upShow (state, [ payload ]) {
            state.show = payload
        },
        upExecuteWd (state, [ index = 0, type ]) {
            const o = state[type]
            state.executeWd = o.stack[index]
        },
        upCurrentExe (state, [ type ]) {
            state.currentExe = type
        },
        upShowBlockWindow (state, [ val ]) {
            state.showBlockWindow = val
        },
        upLock (state, [ val, type ]) {
            Object.assign(state[type], { lock: val })
        },
        upShowBox (state, [ payload ]) {
            state.showBox = payload
        },
        upShowMissionIntro (state, [ payload ]) {
            state.showMissionIntro = payload
        }
    }
}
